// extracted by mini-css-extract-plugin
export default {"tips":"VerifyCode_tips_NlxXP","errorTips":"VerifyCode_errorTips_QQuc7","countdown":"VerifyCode_countdown_u_8dL","regainBtn":"VerifyCode_regainBtn_u1GYn"};